import {StayStatusElement as CommonStayStatusElement} from "crqlar-react-common/dist/components/uiElements/StayStatusElement";

export const StayStatusElement = CommonStayStatusElement;
